import { render, staticRenderFns } from "./menuSyncing.vue?vue&type=template&id=239daaab&scoped=true"
import script from "./menuSyncing.vue?vue&type=script&lang=ts"
export * from "./menuSyncing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239daaab",
  null
  
)

export default component.exports